/** Ruta pública `/olvide-contrasena` (T056 · US2): solicitud del enlace de restablecimiento. */
import { createFileRoute } from '@tanstack/react-router';

import { ForgotPasswordPage } from '../features/auth/forgot-page';

export const Route = createFileRoute('/olvide-contrasena')({
  component: ForgotPasswordPage,
});
